angular.module('app.filters').filter('sdiLinkRate', () => {
    const LINK_RATE_11_88_GBPS = 0;
    const LINK_RATE_5_94_GBPS  = 1;
    const LINK_RATE_2_97_GBPS  = 2;
    const LINK_RATE_1_48_GBPS  = 3;
    const LINK_RATE_0_27_GBPS  = 4;
    return function(rate) {
        if (rate === LINK_RATE_11_88_GBPS) {
            return '11.88 Gbps (12G-SDI)';
        } else if (rate === LINK_RATE_5_94_GBPS) {
            return '5.94 Gbps (6G-SDI)';
        } else if (rate === LINK_RATE_2_97_GBPS) {
            return '2.97 Gbps (3G-SDI)';
        } else if (rate === LINK_RATE_1_48_GBPS) {
            return '1.48 Gbps (HD-SDI)';
        } else if (rate === LINK_RATE_0_27_GBPS) {
            return '270 Mbps (SDI)';
        } else {
            return 'None or unknown';
        }
    }
});


// WEBPACK FOOTER //
// ./filters/sdi_link_rate.js